/*
 * Badge Goal Label Configuration for locales and overrides
 */

import { AchievementName } from '@helios/achievement';
import { ACHIEVEMENT_TO_TARGET_MAP } from '../badgeConfig';

export const sharedLocaleMap: Record<AchievementName, string> = {
  'data-pioneer': 'profileCompleted',
  'data-powered': 'utilityConnected',
  'fast-learner': 'ptsEarnedWeek',
  'streak-rookie': 'weekGoalStreak',
  '4-week-streak': 'weekGoalStreak',
  '6-week-streak': 'weekGoalStreak',
  '8-week-streak': 'weekGoalStreak',
  'streak-pro': 'weekGoalStreak',
  'exported-50-kwh': 'kwhExported',
  'exported-100-kwh': 'kwhExported',
  'exported-300-kwh': 'kwhExported',
  'exported-500-kwh': 'kwhExported',
  'exported-700-kwh': 'kwhExported',
  'exported-1000-kwh': 'kwhExported',
  'weekly-warrior': 'weeksOfEnergyAction',
  'power-user': 'weeksOfEnergyAction',
  'trivia-first-correct': 'triviaStreak',
  'trivia-streak-5': 'triviaStreak',
  'trivia-streak-10': 'triviaStreak',
  'trivia-streak-15': 'triviaStreak',
  'trivia-streak-20': 'triviaStreak',
  'trivia-streak-30': 'triviaStreak',
  'trivia-streak-50': 'triviaStreak',
  'trivia-streak-100': 'triviaStreak',
  'solar-pro': 'questCompleted',
  'hvac-expert': 'questCompleted',
  'battery-savvy': 'questCompleted',
};

// For any labels that are different between achieved and unachieved state
export const achievedLocaleMap: Record<AchievementName, string> = {
  ...sharedLocaleMap,
};

export const unachievedLocaleMap: Record<AchievementName, string> = {
  ...sharedLocaleMap,
  'data-pioneer': 'profileCompletion',
  'data-powered': 'connectUtility',
  'solar-pro': 'completeQuest',
  'hvac-expert': 'completeQuest',
  'battery-savvy': 'completeQuest',
};

// explicit overrides for any totals that shouldn't be shown in labels
export const unachievedTargetDisplayMap: Record<AchievementName, number | string | undefined> = {
  ...ACHIEVEMENT_TO_TARGET_MAP,
  'data-powered': undefined, // "connect utility"
  'solar-pro': undefined, // discrete achievement with no target
  'hvac-expert': undefined, // discrete achievement with no target
  'battery-savvy': undefined, // discrete achievement with no target
};
export const achievedTargetDisplayMap: Record<AchievementName, number | string | undefined> = {
  ...unachievedTargetDisplayMap,
  'data-pioneer': undefined, // "profile completion"
};

// total labels that show percent instead of absolute numbers
export const shouldShowCompletionPercent: AchievementName[] = ['data-pioneer'];

// badges that should show progress numbers and use "<number> of <total>" format
export const shouldShowProgressAndTotal: AchievementName[] = [
  'data-pioneer',
  'fast-learner',
  'streak-rookie',
  '4-week-streak',
  '6-week-streak',
  '8-week-streak',
  'streak-pro',
  'exported-50-kwh',
  'exported-100-kwh',
  'exported-300-kwh',
  'exported-500-kwh',
  'exported-700-kwh',
  'exported-1000-kwh',
  'weekly-warrior',
  'power-user',
  'trivia-first-correct',
  'trivia-streak-5',
  'trivia-streak-10',
  'trivia-streak-15',
  'trivia-streak-20',
  'trivia-streak-30',
  'trivia-streak-50',
  'trivia-streak-100',
];
